import { IBenefitsInfo } from '~views/dashboard/loyalty-benefits/ILoyaltyBenefits';
import { IRewardsInfo } from '~views/dashboard/loyalty-rewards/ILoyaltyRewards';

export type PriorityOrderSort = 'avl' | 'redeemed' | 'ineligible';
export type CategoryOrderSort = 'discountValue' | 'discountPencent' | 'sku' | 'choiceOfSku' | 'shipping' | 'bonusPoints';
type Offers = IBenefitsInfo[] | IRewardsInfo[];

const DEFAULT_PRIORITY_ORDER_SORT_VALUES: PriorityOrderSort[]  = ['avl', 'redeemed', 'ineligible'];
const DEFAULT_CATEGORY_ORDER_SORT_VALUES: CategoryOrderSort[] = ['discountValue', 'discountPencent', 'sku', 'choiceOfSku', 'shipping', 'bonusPoints'];
const CATEGORY_CLASSES = {
    discountValue: ['FlatDiscount'],
    discountPencent: ['PercentDiscount', 'OfferCartPercentDiscount'],
    sku: ['FullSizeSkus', 'Skus'],
    choiceOfSku: ['ChoiceOfSkus', 'FullSizeChoiceOfSkus'],
    shipping: ['ShippingDiscountAppeasement', 'ShippingDiscountFree', 'ShippingDiscountFreeWithStepUp',
        'ShippingDiscountMinusCost', 'ShippingDiscount', 'ShippingDiscountSetCost', 'ShippingDiscountUpgrade', 'ShippingMethod'],
    bonusPoints: ['FlatPointsImmediate', 'FlatPoints', 'PercentPoints']
};

function getHighestPriorityClass(classes: string[], orderBy: string[][]) {
    for (const categoryClasses of orderBy) {
        for (const cls of classes) {
            if (categoryClasses?.includes(cls)) {
                return cls;
            }
        }
    }

    return classes[0];
}

function sortOffersByHighestPriorityClass(offersInfo: Offers, categoryOrder: CategoryOrderSort[]) {
    const orderedCategories: string[][] = [];
    const classPriorityMap: Record<string, number> = {};
    categoryOrder.forEach((category, index) => {
        CATEGORY_CLASSES[category]?.forEach(cls => {
            classPriorityMap[cls] = index;
        });
        orderedCategories.push(CATEGORY_CLASSES[category]);
    });
    offersInfo.forEach(offerInfo => {
        const { benefits } = offerInfo;
        if (!offerInfo.highestPriorityClass) {
            offerInfo.highestPriorityClass = getHighestPriorityClass(benefits.map(b => b.class), orderedCategories);
        }
    });

    return offersInfo.sort((a, b) => {
        const priorityA = classPriorityMap[a.highestPriorityClass || ''] ?? Infinity;
        const priorityB = classPriorityMap[b.highestPriorityClass || ''] ?? Infinity;

        return priorityA - priorityB;
    });
}

export function getSortedOffersInfo(offerssDataFormatted: Offers,
    priorityOrder: PriorityOrderSort[] = DEFAULT_PRIORITY_ORDER_SORT_VALUES,
    categoryOrder: CategoryOrderSort[] = DEFAULT_CATEGORY_ORDER_SORT_VALUES) {
    const sortedOfferssBypriorityClass = sortOffersByHighestPriorityClass(offerssDataFormatted, categoryOrder);
    const sortMap = { avl: [] as Offers, redeemed: [] as Offers, ineligible: [] as Offers };
    sortMap.avl = sortedOfferssBypriorityClass.filter(offer => {
        return offer.meetsCriteria;
    }) || [] as Offers;

    sortMap.redeemed = sortedOfferssBypriorityClass.filter(offer => {
        return !offer.meetsCriteria && offer.redeemedStatus;
    }) || [] as Offers;

    sortMap.ineligible = sortedOfferssBypriorityClass.filter(offer => {
        return !offer.meetsCriteria && !offer.redeemedStatus;
    }) || [] as Offers;

    if (DEFAULT_PRIORITY_ORDER_SORT_VALUES.find(priority => priorityOrder.includes(priority))) {
        return priorityOrder.map(priority => sortMap[priority]).flat();
    } else {
        return DEFAULT_PRIORITY_ORDER_SORT_VALUES.map(priority => sortMap[priority]).flat();
    }

}